/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type CleansingCategoriesEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const cleansingCategoriesEntryPoint: EntryPoint<CleansingCategoriesEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForInteraction<CleansingCategoriesEntryPointComponent>(
			/* webpackChunkName: "async-cleansing-categories" */ './CleansingCategoriesPage.tsx',
		),
		getPreloadProps: () => ({
			extraProps: {},
		}),
	});
